import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getDecisionMakerResponsePageData } from './api';
import type { DecisionMakerResponsePageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: DecisionMakerResponsePageDataContext,
	Provider: DecisionMakerResponsePageDataContextProvider,
	useContext: useDecisionMakerResponsePageData,
	useAsyncData: useDecisionMakerResponsePageDataFromApi,
	prefetchAsyncData: prefetchDecisionMakerResponsePageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'DecisionMakerResponsePageDataContext',
	dataProperty: 'pageData',
	getData: getDecisionMakerResponsePageData,
	getUniqueId: ({ petitionSlugOrId, responseId, userId }) => [petitionSlugOrId, responseId, userId || ''].join('|'),
	hookDeps: ({ petitionSlugOrId, responseId, userId }) => [petitionSlugOrId, responseId, userId],
	errorHandler: pageDataErrorHandler<DecisionMakerResponsePageDataErrorCode>(),
});
